export const homeConstants = {

  GET_REPORT_E_COMMERCE_REQUEST: "GET_REPORT_E_COMMERCE_REQUEST",
  GET_REPORT_E_COMMERCE_SUCCESS: "GET_REPORT_E_COMMERCE_SUCCESS",
  GET_REPORT_E_COMMERCE_FAILURE: "GET_REPORT_E_COMMERCE_FAILURE",

  GET_ALL_EMPLOYER_USER_LIST_REQUEST: "GET_ALL_EMPLOYER_USER_LIST_REQUEST",
  GET_ALL_EMPLOYER_USER_LIST_SUCCESS: "GET_ALL_EMPLOYER_USER_LIST_SUCCESS",
  GET_ALL_EMPLOYER_USER_LIST_FAILURE: "GET_ALL_EMPLOYER_USER_LIST_FAILURE",

  SET_SOCKET: "SET_SOCKET",
  CLEAR_SOCKET: "CLEAR_SOCKET",

};
